import { render, staticRenderFns } from "./BackgorundCircle.vue?vue&type=template&id=dbecdca4"
import script from "./BackgorundCircle.vue?vue&type=script&lang=js"
export * from "./BackgorundCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports